// extracted by mini-css-extract-plugin
export default {"card__img":"reviewCard_card__img__SxHeJ"};